import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";

// Define a service using a base URL and expected endpoints
export const apBackgroundDetailsAPI = createApi({
  reducerPath: "apBackgroundDetailsAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getAPBackgroundDetails: builder.query<any, APBackgroundArgTypes>({
      query: ({ apCode }) => ({
        url: `/am/ap/${apCode}/apbackground`,
        method: "GET",
      }),
    }),
    setAPBackgroundDetails: builder.mutation<
      any,
      APBackgroundMutationArgTypes
    >({
      query: ({ apCode, payload }) => ({
        url: `/am/ap/${apCode}/apbackground`,
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAPBackgroundDetailsQuery,
  useSetAPBackgroundDetailsMutation
} = apBackgroundDetailsAPI;
